module.exports = __webpack_public_path__ + "media/invite/activate-5dcfe63e.svg";